import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Content from "@components/layout/content/content";

const ProtectedRoute = () => {
  const { customer, actions } = ZuAuthStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifySession = async () => {
      await actions.checkIfHaveSession();
      setLoading(false);
    };

    verifySession();
  }, [actions]);

  if (loading) {
    return <></>;
  }

  // If NOT logged in, redirect to login
  // If logged in, render with the Content (sidebar + topbar)
  return customer ? (
    <Content>
      <Outlet />
    </Content>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
